export enum TabIds {
  ALL = 'all',
  NEW = 'recently_assigned',
  TODAY = 'set_for_today',
  NEXT  = 'next_7_days',
  LATER = 'rest',
  BY_YOU = 'by_you',
  BY_ANOTHER_PROFESSIONAL = 'by_another_professional',
  OUTSIDE_DOULEUTARAS = 'outside_douleutaras',
  BY_THE_CUSTOMER = 'by_the_customer'
}

export enum BidListStatuses {
  CURRENT = 'current',
  CONCLUDED = 'concluded',
  CANCELLED = 'cancelled'
}

// List of possible options of "tab" attribute coming from API
export const BidAttributeTabIds = {
  ALL: 'all',
  REST: 'rest',
  NEXT_7_DAYS: 'next_7_days',
  SET_FOR_TODAY: 'set_for_today',
  RECENTLY_ASSIGNED: 'recently_assigned',
  BY_YOU: 'by_you',
  BY_ANOTHER_PROFESSIONAL: 'by_pro',
  OUTSIDE_DOULEUTARAS: 'outside',
  CONCLUDED: 'concluded',
  CONCLUDED_BY_PRO: 'concluded_by_pro',
  CONCLUDED_BY_ANOTHER_PRO: 'concluded_by_another_pro',
  CONCLUDED_OUTSIDE: 'concluded_outside',
  CANCELLED: 'cancelled',
  CANCELLED_BY_PRO: 'cancelled_by_pro',
  CANCELLED_BY_CLIENT: 'cancelled_by_client'
};

export const JOB_INTENT_OPTIONS: Array<String> = [
  '1'
];

export enum CrudModel {
  CREATE,
  READ,
  UPDATE,
  DELETE
}

export type BidAttributeTabType = typeof BidAttributeTabIds[keyof typeof BidAttributeTabIds];
